export default {
  methods: {
    seoName(str) {
      return str
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '');
    }
  }
};
